import Icon from '@uikit/components/Icon/Icon';
import Stack from '@uikit/components/Stack/Stack';
import scssVars from '../../styles/_export.module.scss';
import {
  AppleAppStoreButton,
  GooglePlayStoreButton,
} from '../AppStoreButtons/AppStoreButton';
import { List } from '../List/List';
import { Text } from '../Text/Text';
import styles from './AppSteps.module.scss';

export const AppSteps = () => {
  return (
    <Stack
      flexDirection={{ initial: 'column', md: 'row' }}
      justifyContent="center"
      alignItems="center"
      gap={{ initial: '2.5rem', md: '5rem' }}
    >
      <Stack.Item>
        <Stack gap={{ initial: '2rem', md: '3rem' }} className="">
          <Text className={styles.title} weight={300} gradient>
            <strong>Jetzt App installieren</strong>
            <br />
            und direkt laden.
          </Text>

          <Stack
            flexDirection={{ initial: 'column', xxs: 'row' }}
            justifyContent="center"
            alignItems="center"
            gap={'0.5rem'}
          >
            <GooglePlayStoreButton clickContext="Jetzt App installieren und direkt laden" />
            <AppleAppStoreButton clickContext="Jetzt App installieren und direkt laden" />
          </Stack>
        </Stack>
      </Stack.Item>
      <Stack.Item>
        <List
          fontSize={18}
          desktopScale={1.25}
          color={scssVars.colorYellow100}
          numeric={true}
          rows={[
            { content: 'In der App registrieren' },
            { content: 'Zahlungsmittel hinterlegen' },
            { content: 'Persönliche Infos hinzufügen' },
          ]}
        />

        <Stack
          gap={'0.5rem'}
          flexDirection="row"
          className={styles.success}
          alignItems={{ initial: 'stretch' }}
        >
          <Icon
            variant="user/thumbs-up"
            size="iconSize32"
            className={styles.thumbsUp}
            isOutlined
          />

          <span>Fertig!</span>
        </Stack>
      </Stack.Item>
    </Stack>
  );
};
